import { Box, Typography, useTheme, TextField, CircularProgress, InputAdornment, Divider, IconButton, Paper, Modal, Stack } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear'; // Import the clear icon
import { tokens } from "../../theme";
import { djangoApi } from "../../utils/axios/axios.utils";

import { useState, useRef, useEffect } from "react";
import PesquisarProdutosTable from "../../components/pesquisar-produtos-table";
import CloseIcon from '@mui/icons-material/Close'; // ou DeleteIcon
import { motion, AnimatePresence } from "framer-motion";

import Swal from 'sweetalert2'
import toast from "react-hot-toast";
import SemProduto from "../../assets/img/produto-sem-imagem.jpg"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

import { handleExport } from "./excel-export";

import { Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';

import { useSelector } from "react-redux";
import { selectSellers } from "../../store/sellers/sellers.selector";
import { InputLabel, Select, MenuItem, Chip } from '@mui/material';
import { pink } from '@mui/material/colors';
import SortByAlphaIcon from '@mui/icons-material/SortByAlpha';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import { selectIsStaffUser } from "../../store/user/user.selector";


const PesquisarProdutosPage = () => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const inputRef = useRef();
    const sellersData = useSelector(selectSellers);
    const isStaff = useSelector(selectIsStaffUser);

    const [selectedValue, setSelectedValue] = useState('vendedoras');
    const [lastKitsPerSeller, setLastKitsPerSeller] = useState("5");

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };

    const [modalOpen, setModalOpen] = useState(false)
    const [modalImage, setModalImage] = useState(null)


    const [isLoadingInfo, setIsLoadingInfo] = useState(false);
    const [dataUser, setDataUser] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [doneProds, setDoneProds] = useState([]);


    const [searchQuery, setSearchQuery] = useState("");

    const [selectedItems, setSelectedItems] = useState([]);

    const [sortAsc, setSortAsc] = useState(true);

    const handleChangeSellersSelector = (event) => {
        setSelectedItems(event.target.value);
    };
    const handleClear = () => {
        setSelectedItems([]);
    };


    const handleSort = () => {
        const sorted = [...doneProds].sort((a, b) =>
            sortAsc
                ? a - b
                : b - a
        );
        setDoneProds(sorted);
        setSortAsc(!sortAsc);
    };

    useEffect(() => {
        if (selectedItems?.length > 0) {
            const newProdsArr = dataUser.filter((data) => selectedItems.includes(data.nome))
            setFilteredUsers(newProdsArr)
        } else {
            setFilteredUsers(dataUser)
        }
    }, [selectedItems, dataUser]);

    const getSellerSelsInfo = async (value) => {
        setIsLoadingInfo(true)
        try {
            const showMissing = selectedValue === "vendedoras";

            const kitsLimit = Number(lastKitsPerSeller);

            if (
                showMissing &&
                (!Number.isInteger(kitsLimit) || kitsLimit < 1)
            ) {
                Swal.fire({
                    icon: "warning",
                    title: "Quantidade de kits inválida",
                    text: "Informe pelo menos 1 kit para realizar a consulta.",
                    confirmButtonColor: "#d33",
                    confirmButtonText: "Ok",
                });
                return;
            }

            const params = new URLSearchParams({
                show_missing: String(showMissing),
            });

            if (showMissing) {
                params.set("last_kits_per_seller", String(kitsLimit));
            }

            const res = await djangoApi.get(
                `products/register_prods/${value}/get_list_kits_prods_sellers_in/?${params.toString()}`,
                {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            const { data, status } = res
            if (status === 200) {
                // setDataUser(data.data)
                // console.log('data here: ', data)
                if (!data.data.prod) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Produto não encontrado!!',
                        text: `O Produto ${value} não está cadastrado.`,
                        confirmButtonColor: '#d33',
                        confirmButtonText: 'Ok',
                    });
                    return
                }

                if (selectedValue === 'produto') {
                    setModalImage(data.data.prod?.imageUrl || '/sem-produto.jpg');
                    setModalOpen(true);
                    setSearchQuery("");
                    return;

                }
                toast.custom(
                    (t) => (
                        <div
                            style={{
                                padding: "16px",
                                background: "#e8f5e9", // light green
                                borderRadius: "12px",
                                boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
                                border: "1px solid #4caf50",
                                width: "320px",
                                transform: t.visible ? "translateY(0)" : "translateY(-40px)",
                                opacity: t.visible ? 1 : 0,
                                transition: "all 0.4s ease-in-out",
                                position: "relative",
                                display: "flex",
                                flexDirection: "column",
                                gap: "12px",
                            }}
                        >
                            {/* Botão fechar */}
                            <button
                                onClick={() => toast.dismiss(t.id)}
                                style={{
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    color: "#4caf50",
                                    fontWeight: "bold",
                                    lineHeight: 1,
                                }}
                                aria-label="Fechar"
                                title="Fechar"
                            >
                                ×
                            </button>

                            <div style={{ fontSize: 15, color: "black", fontWeight: "bold" }}>
                                {value}
                            </div>
                            <Box
                                component="img"
                                src={data.data.prod?.imageUrl ? data.data.prod.imageUrl : SemProduto}
                                alt={"produto"}
                                onError={(e) => {
                                    e.currentTarget.onerror = null; // impede loop
                                    e.currentTarget.src = SemProduto;
                                }}
                                sx={{
                                    width: "100%",
                                    height: "400px",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                    border: "2px solid #4caf50",
                                }}
                            />
                        </div>
                    ),
                    {
                        duration: 3000,
                        position: "top-right", // ✅ toast no topo direito
                    }
                );

                setDoneProds((prev) => {
                    return [value, ...prev]
                })
                const newArr = data?.data?.selers_has_not_prod?.map((seller) => {
                    return ({
                        ...seller,
                        prod: data.data.prod
                    })
                })
                setDataUser((prev) => {
                    return [...prev, ...newArr]
                })

                setSearchQuery("")
            }
            return
        } catch (err) {
            console.log("Erro consultar o produto:", searchQuery, err);
            window.alert(err);
            setIsLoadingInfo(false)
        } finally {
            // pass
            setIsLoadingInfo(false)
        }
    };

    const handleSearch = (value) => {
        setSearchQuery(value)
        if (value.length === 6) {
            const alreadyExists = doneProds.includes(value);
            if (alreadyExists) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Produto já consultado',
                    text: `O ID ${value} já foi pesquisado.`,
                    confirmButtonColor: '#d33',
                    confirmButtonText: 'Ok',
                });
                return;
            }
            console.log('value', value)
            getSellerSelsInfo(value)
        }
    }

    // Restore focus after loading ends
    useEffect(() => {
        if (!isLoadingInfo && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isLoadingInfo]);


    useEffect(() => {
        console.log('data user: ', dataUser)
    }, [dataUser]);

    return (
        <>

            <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
                <Box
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        bgcolor: 'rgba(0,0,0,0.9)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999,
                    }}
                >
                    <IconButton
                        onClick={() => setModalOpen(false)}
                        sx={{
                            position: 'absolute',
                            top: 16,
                            right: 16,
                            color: 'white',
                            backgroundColor: 'rgba(255,255,255,0.1)',
                            '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' },
                        }}
                    >
                        <CloseIcon fontSize="large" />
                    </IconButton>

                    <Box
                        component="img"
                        src={modalImage}
                        onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = '/sem-produto.jpg';
                        }}
                        alt="Imagem produto"
                        sx={{
                            maxWidth: '90vw',
                            maxHeight: '90vh',
                            objectFit: 'contain',
                            borderRadius: 2,
                            boxShadow: 6,
                        }}
                    />
                </Box>
            </Modal>
            <Box
                mt={10}
                pl={4}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '40px'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row-reverse',
                        gap: '40px'
                    }}
                >
                    <Box
                        sx={{
                            alignSelf: 'end',
                            marginRight: '50px'
                        }}
                    >
                        <Typography>
                            Buscar Vendedoras que ainda não receberam produtos específicos!
                        </Typography>
                    </Box>

                    <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-start", alignItems: "center", gap: '60px' }}>

                        <TextField
                            variant="standard"
                            placeholder="Insira um ID"
                            value={searchQuery}
                            onChange={(e) => handleSearch(e.target.value)}
                            inputProps={{ maxLength: 6 }}
                            disabled={isLoadingInfo}
                            inputRef={inputRef}
                            InputProps={{
                                endAdornment: (
                                    isLoadingInfo ? (
                                        <InputAdornment position="end">
                                            <CircularProgress size={16} color="inherit" sx={{ marginBottom: '6px' }} />
                                        </InputAdornment>
                                    ) : null
                                ),
                            }}
                            sx={{
                                width: "100px",
                                marginRight: "10px",
                                '& .MuiInput-underline:before': {
                                    borderBottomColor: 'whitesmoke',
                                },
                                '& .MuiInput-underline:hover:before': {
                                    borderBottomColor: 'rgba(153,153,153,0.2)',
                                },
                                '& .MuiInput-underline:after': {
                                    borderBottomColor: 'rgba(204,204,204,0.5)',
                                },
                            }}
                        />
                        <TextField
                            type="number"
                            variant="standard"
                            label="Últimos kits"
                            value={lastKitsPerSeller}
                            onChange={(e) => setLastKitsPerSeller(e.target.value)}
                            disabled={isLoadingInfo || selectedValue !== "vendedoras"}
                            inputProps={{
                                min: 1,
                                step: 1,
                            }}
                            helperText={
                                selectedValue === "vendedoras"
                                    ? "Consulta por vendedora"
                                    : "Disponível na consulta de vendedoras"
                            }
                            sx={{
                                width: "120px",
                                "& .MuiInput-underline:before": {
                                    borderBottomColor: "whitesmoke",
                                },
                                "& .MuiInput-underline:hover:before": {
                                    borderBottomColor: "rgba(153,153,153,0.2)",
                                },
                                "& .MuiInput-underline:after": {
                                    borderBottomColor: "rgba(204,204,204,0.5)",
                                },
                            }}
                        />
                        <IconButton onClick={handleSort} sx={{ mt: '-4px' }} title={`Ordenar ${!sortAsc ? 'Z-A' : 'A-Z'}`}>
                            <SortByAlphaIcon sx={{ transform: !sortAsc ? 'rotate(0deg)' : 'rotate(180deg)', transition: 'transform 0.2s' }} />
                        </IconButton>
                        <FormControl component="fieldset">
                            {/* <FormLabel component="legend">Selecione uma Opção</FormLabel> */}
                            <RadioGroup value={selectedValue} onChange={handleChange} row>
                                <FormControlLabel value="vendedoras" control={<Radio color="success" />} label="Vendedoras" />
                                <FormControlLabel value="produto" control={<Radio color="success" />} label="Produto" />
                            </RadioGroup>
                        </FormControl>
                        {
                            filteredUsers?.length > 0 && (
                                <button
                                    onClick={() => handleExport(filteredUsers)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        backgroundColor: colors.pink[500],
                                        color: colors.greenAccent[500],
                                        border: 'none',
                                        borderRadius: '50%',
                                        padding: '10px 16px',
                                        cursor: 'pointer',
                                        fontSize: '24px',
                                        gap: '8px',
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFileExcel} />
                                </button>
                            )
                        }
                        {
                            sellersData && (
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <FormControl sx={{ width: '300px' }}>
                                        <InputLabel id="multi-select-label">Vendedoras {isStaff && `(${sellersData?.filter((seller) => seller.firebase_is_active === true)?.length})`}</InputLabel>
                                        <Select
                                            labelId="multi-select-label"
                                            multiple
                                            value={selectedItems}
                                            onChange={handleChangeSellersSelector}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        maxHeight: 700, // Set max height for dropdown
                                                    },
                                                },
                                            }}
                                            renderValue={(selected) => (
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        gap: 0.5,
                                                        overflow: 'hidden',
                                                    }}
                                                >
                                                    {selected.map((value) => (
                                                        <Chip
                                                            key={value}
                                                            label={value}
                                                            sx={{
                                                                maxWidth: 100,
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'nowrap',
                                                            }}
                                                        />
                                                    ))}
                                                </Box>
                                            )}
                                        >
                                            {sellersData.filter((seller) => seller.firebase_is_active === true).map((seller, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={seller.nome}
                                                    selected={selectedItems.includes(seller.nome)} // use MUI's selected style
                                                    sx={{
                                                        maxWidth: '100%',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis',
                                                        '&.Mui-selected': {
                                                            backgroundColor: pink[700],
                                                            color: '#fff',
                                                            '&:hover': {
                                                                backgroundColor: pink[900],
                                                            },
                                                        },
                                                    }}
                                                >
                                                    {seller.nome}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    {
                                        selectedItems?.length > 0 &&
                                        <IconButton onClick={handleClear} title="Limpar seleção">
                                            <ClearIcon />
                                        </IconButton>
                                    }
                                </Stack>
                            )
                        }
                    </Box>
                </Box>
                {
                    doneProds?.length > 0 && (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                minHeight: '500px',
                                gap: '10px',
                                marginRight: '15px'
                            }}
                        >
                            <Box
                                sx={{
                                    width: '71%'
                                }}
                            >
                                <PesquisarProdutosTable
                                    data={filteredUsers}
                                    prods={doneProds}
                                    sellersName={selectedItems}
                                />
                            </Box>
                            <Divider orientation="vertical" />
                            <Box sx={{ width: '10%' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} mb={2}>
                                    <Typography fontWeight="bold" sx={{ marginBottom: '15px', margin: 0 }}>
                                        Produtos - {doneProds?.length}
                                    </Typography>
                                    <IconButton
                                        size="small"
                                        onClick={() => {
                                            setDoneProds([]);
                                        }}
                                    >
                                        <CloseIcon fontSize="small" sx={{ color: colors.grey[100] }} />
                                    </IconButton>
                                </Box>
                                <Box>
                                    <AnimatePresence>
                                        {doneProds
                                            .map((data, i) => (
                                                <motion.div
                                                    key={data} // use algo único e fixo aqui
                                                    initial={{ opacity: 0, y: -10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    exit={{ opacity: 0, y: 10 }}
                                                    layout // isto ajuda no movimento fluido
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <Box
                                                        component={Paper}
                                                        elevation={8}
                                                        mb={1}
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="space-between"
                                                        sx={{
                                                            backgroundColor: colors.pink[800],
                                                            borderRadius: '8px',
                                                            padding: '4px 8px'
                                                        }}
                                                    >
                                                        <Box>
                                                            <span style={{ color: colors.grey[300] }}>{i + 1}.</span> {data}
                                                        </Box>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => {
                                                                const removedItem = doneProds[i]; // valor do produto sendo removido

                                                                // Atualiza a lista de produtos exibidos
                                                                const newList = doneProds.filter((_, index) => index !== i);
                                                                setDoneProds(newList);

                                                                // Remove também do dataUser onde o id_produto for igual ao que está sendo removido
                                                                setDataUser(prev =>
                                                                    prev.filter(user => user.prod?.id_produto !== removedItem)
                                                                );
                                                            }}
                                                        >
                                                            <CloseIcon fontSize="small" sx={{ color: colors.grey[100] }} />
                                                        </IconButton>
                                                    </Box>
                                                </motion.div>
                                            ))}
                                    </AnimatePresence>
                                </Box>
                            </Box>
                            <Divider orientation="vertical" />
                            <Box sx={{ width: '14%' }}>
                                <Typography fontWeight="bold" sx={{ marginBottom: '15px' }}>
                                    Vendedoras - {selectedItems?.length}
                                </Typography>
                                <Box>
                                    <AnimatePresence>
                                        {selectedItems
                                            .map((data, i) => (
                                                <motion.div
                                                    key={data} // use algo único e fixo aqui
                                                    initial={{ opacity: 0, y: -10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    exit={{ opacity: 0, y: 10 }}
                                                    layout // isto ajuda no movimento fluido
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <Box
                                                        component={Paper}
                                                        elevation={8}
                                                        mb={1}
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="space-between"
                                                        sx={{
                                                            backgroundColor: colors.pink[800],
                                                            borderRadius: '8px',
                                                            padding: '4px 8px'
                                                        }}
                                                    >
                                                        <Box>
                                                            <span style={{ color: colors.grey[300] }}>{i + 1}.</span>{' '}
                                                            {data}
                                                        </Box>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => {
                                                                // Remove também do dataUser onde o id_produto for igual ao que está sendo removido
                                                                setSelectedItems((prev) => {
                                                                    return prev.filter((seller) => seller !== data)
                                                                })
                                                            }}
                                                        >
                                                            <CloseIcon fontSize="small" sx={{ color: colors.grey[100] }} />
                                                        </IconButton>
                                                    </Box>
                                                </motion.div>
                                            ))}
                                    </AnimatePresence>
                                </Box>
                            </Box>
                        </Box>
                    )
                }
            </Box>
        </>
    );
}

export default PesquisarProdutosPage;